// src/redux/actions/dashboard.actions.ts
import {createAsyncThunk} from '@reduxjs/toolkit';
import {
    getSpasWithErrors,
    getSpasWithTempDifference,
    getSpasConnectedThisWeek,
    getSpasConnectedLastWeek,
    getSpasWithSbHours,
    getOnlineMovedSpas,
    getSpaLocations
} from '../../services/api/dashboard.api';
import RootState from '../states/root.state';

export const fetchSpasWithErrors = createAsyncThunk<any, void, { rejectValue: string; state: RootState }>(
    'dashboard/fetchSpasWithErrors',
    async (_, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;
            return await getSpasWithErrors(token);
        } catch (error: any) {
            return rejectWithValue(error.response?.data?.message??error.response?.data?.message??"An error occurred while fetching spas with errors");
        }
    }
);

export const fetchSpasWithTempDifference = createAsyncThunk<any, void, { rejectValue: string; state: RootState }>(
    'dashboard/fetchSpasWithTempDifference',
    async (_, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;
            return await getSpasWithTempDifference(token);
        } catch (error: any) {
            return rejectWithValue(error.response?.data?.message??error.response?.data?.message??"An error occurred while fetching spas with temperature difference");
        }
    }
);

export const fetchSpasConnectedThisWeek = createAsyncThunk<any, void, { rejectValue: string; state: RootState }>(
    'dashboard/fetchSpasConnectedThisWeek',
    async (_, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;
            return await getSpasConnectedThisWeek(token);
        } catch (error: any) {
            return rejectWithValue(error.response?.data?.message??error.response?.data?.message??"An error occurred while fetching spas connected this week");
        }
    }
);

export const fetchSpasConnectedLastWeek = createAsyncThunk<any, void, { rejectValue: string; state: RootState }>(
    'dashboard/fetchSpasConnectedLastWeek',
    async (_, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;
            const response =  await getSpasConnectedLastWeek(token);

            return response;
        } catch (error: any) {
            return rejectWithValue(error.response?.data?.message??error.response?.data?.message??"An error occurred while fetching spas connected last week");
        }
    }
);

export const fetchSpasWithSbHours = createAsyncThunk<any, void, { rejectValue: string; state: RootState }>(
    'dashboard/fetchSpasWithSbHours',
    async (_, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;
            return await getSpasWithSbHours(token);
        } catch (error: any) {
            return rejectWithValue(error.response?.data?.message??error.response?.data?.message??"An error occurred while fetching spas in manual mode");
        }
    }
);

export const fetchSpaLocations = createAsyncThunk<any, void, { rejectValue: string; state: RootState }>(
    'dashboard/fetchSpaLocations',
    async (_, {rejectWithValue, getState}) => {
        try {
            const {user, dashboard} = getState();
            const token = user.accessToken;

            // The map only pins spas that need attention. Those GUID sets are already
            // loaded, so send their union and let the server return coordinates for the
            // located ones — the request stays bounded by the number of flagged spas.
            const guids = Array.from(new Set([
                ...(dashboard.spasWithErrors.spa_guids ?? []),
                ...(dashboard.spasWithTempDifference.spa_guids ?? []),
                ...(dashboard.spasWithSbHours.spa_guids ?? []),
            ]));

            return await getSpaLocations(token, guids);
        } catch (error: any) {
            return rejectWithValue(error.response?.data?.message??"An error occurred while fetching spa locations");
        }
    }
);

export const fetchOnlineMovedSpas = createAsyncThunk<any, void, { rejectValue: string; state: RootState}>(
    'dashboard/fetchOnlineMovedSpas',
    async (_, {rejectWithValue, getState}) => {
      try {
  
        const {user} = getState();
        const token = user.accessToken;
  
        const response = await getOnlineMovedSpas(token);
        return response.data;
      } catch (error: any) {
          if (error.response) {
              return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while fetching online moved spas.");
          } else {
              return rejectWithValue('An error occurred while fetching online moved spas.');
          }
      }
    }
  );